import { useContext } from 'react';
import { PortalStatusContext } from '../providers/PortalStatusProvider';
function usePortalStatus() {
  return useContext(PortalStatusContext);
}
export default usePortalStatus;